import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import { Multiselect } from 'multiselect-react-dropdown';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import dateFormat from 'dateformat';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
// import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import DialogTitle from '@material-ui/core/DialogTitle';
// import Mood from '@material-ui/icons/Mood';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { Divider, makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { triggerUseEffect } from '../../../services/store/actions';

import { CommonConfig } from '../../../../config/common-config';

const useStyles = makeStyles((theme) => ({
    // root: {
    //     flexGrow: 1,
    //     marginTop: theme.spacing(6),
    // },
    button: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
    },
    formControlCall: {
        // margin: theme.spacing(2),
        minWidth: 370,
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
    },

    popContent: {
        fontFamily: 'Rubik',
        color: '#444',
        '& label': {
            fontSize: '18px !important',
            fontWeight: '500',
        },
        '& textarea': {
            borderBottom: '1px solid #ccc',
        },
    },
    popFoot: {
        fontFamily: 'Rubik',
        display: 'initial',
        paddingBottom: '20px',
        '& button': {
            marginLeft: '16px !important',
        },
    },
    remarkDiv: {
        maxHeight: '100px',
        overflowY: 'scroll',
        background: '#e8e7e7',
        paddingLeft: '10px',
        border: '1px solid #d3d3d3',
        borderRadius: '5px',
        wordBreak: 'break-word',
    },
    dialogPaper: {
        minHeight: '40vh',
        maxHeight: '40vh',
        minWidth: '40vw',
    },
    lbl: {
        fontWeight: '600',
        color: 'rgb(0 0 0 / 66%)',
        fontSize: '15px',
    }
}));
export default function FormDialog({ coreTeamMember, itecOpen, handelCloseDeleteAssigniPopUp, onAssignEmployee, deletedEmp, showConfirmDeleteDialoge, handelCloseDeleteEmployeeDialoge, deleteEmployee }) {
    const classes = useStyles();
    const [coreTeam, setCoreTeam] = useState([]);
    const [assigneeArr, setAssigneeArr] = useState([]);

    useEffect(() => {
        ////console.log("deletedEmp:",deletedEmp)
        setCoreTeam(coreTeamMember);
        ////console.log("coreTeamMember:",coreTeamMember);
    }, [coreTeamMember, itecOpen]);

    const handleClose = () => {
        if (itecOpen) {
            handelCloseDeleteAssigniPopUp();
        }
        if (showConfirmDeleteDialoge) {
            handelCloseDeleteEmployeeDialoge();
        }
    };

    const allCoreTeamMultiOptions = (allcoreteam) => {
        const tempEmployee = allcoreteam;
        allcoreteam = [];
        tempEmployee.map((ele, i) => {
            if (ele.empId != deletedEmp.empId) {
                allcoreteam.push(ele);
            }
        })
        const OptionList = allcoreteam.map((data) => ({ name: `${data.empId} - ${data.firstName} ${data.lastName}`, id: data.empId }));
        return OptionList;
    };

    const onSelect = (selectedList, selectedItem) => {
        const assignees = coreTeam.filter(function (item) {
            return item.empId === selectedItem.id;
        });
        const aArr = {
            id: assignees[0].empId,
            emailId: assignees[0].officeEmail,
            name: assignees[0].firstName,
            phoneNumber: assignees[0].mobileNumber,
        };
        setAssigneeArr([...assigneeArr, aArr]);
        //setCoreTeamNames(selectedItem);
    }

    const onRemove = (selectedList, removedItem) => {
        assigneeArr.filter(function (item, index) {
            if (item.id === removedItem.id) {
                return assigneeArr.splice(index, 1);
            }
        });
        setAssigneeArr([...assigneeArr]);
    }

    const save = () => {
        if (itecOpen) {
            onAssignEmployee(assigneeArr);
            handelCloseDeleteAssigniPopUp();
        }
        if (showConfirmDeleteDialoge) {
            deleteEmployee(deletedEmp);
            handelCloseDeleteEmployeeDialoge();
        }
    };

    return (
        <>
            {itecOpen && (
                <Dialog
                    open={itecOpen}
                    onClose={() => handleClose()}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{ fontFamily: 'Rubik' }}
                    classes={{ paper: classes.dialogPaper }}
                // disableBackdropClick
                >
                    <DialogTitle className={classes.formControlCall} id="alert-dialog-title">
                        Assign Task
                    </DialogTitle>
                    <DialogContent>
                        <InputLabel className={classes.lbl} htmlFor="firstAssignee" shrink>
                            Assignee of Team member <span style={{ color: "#ff0a047a" }}>*</span>
                        </InputLabel>
                        <Multiselect
                            options={allCoreTeamMultiOptions(coreTeam)}
                            //selectedValues={formik.values.firstAssignee}
                            onSelect={onSelect}
                            onRemove={onRemove}
                            displayValue="name"
                            showCheckbox={true}
                            closeOnSelect={false}
                            placeholder="Select"
                            showArrow
                        />
                    </DialogContent>
                    <DialogActions className={classes.popFoot}>
                        <Button onClick={() => handleClose()} variant="outlined" color="primary" size="small" className={classes.button}>
                            Cancel
                        </Button>
                        <Button onClick={() => save()} variant="outlined" color="primary" size="small" className={classes.button} autoFocus disabled={assigneeArr && assigneeArr.length ? false : true}>
                            Assign
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
            {showConfirmDeleteDialoge && (
                <Dialog
                    open={showConfirmDeleteDialoge}
                    onClose={() => handleClose()}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{ fontFamily: 'Rubik' }}
                //classes = {{paper: classes.dialogPaper}}
                // disableBackdropClick
                >
                    <DialogTitle className={classes.formControlCall} id="alert-dialog-title">
                        Please confirm
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" className={classes.popContent}>
                            Are you sure you want to delete this record? If Yes press Ok or press Cancel to go back
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className={classes.popFoot}>
                        <Button onClick={() => save()} variant="outlined" color="primary" size="small" className={classes.button} autoFocus>
                            Ok
                        </Button>
                        <Button onClick={() => handleClose()} variant="outlined" color="primary" size="small" className={classes.button}>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}
